<template>
  <div
    class="page vertical-align text-center"
    data-animsition-in="fade-in"
    data-animsition-out="fade-out"
  >
    <div class="page-content vertical-align-middle animation-slide-top animation-duration-1">
      <div class="brand mobile-page" :style="{'margin': '0px auto 75px auto', 'width': '200px'}">
        <img
          class="brand-img"
          src="//files.shebah.com.au/portal/img/shebah-driver-black-text-logo.svg"
          alt="..."
        />
      </div>
      <b-form @submit.prevent="onSubmit" v-if="!successMessage">
      <h2>Change Your Password</h2>
      <p>Input and confirm your new password</p>
        <b-form-group
          id="input-group-1"
          label="Password"
          label-for="password"
          :invalid-feedback="formErrors.password"
          :state="(typeof formErrors.password !== 'undefined') ? false : true"
        >
          <b-form-input
            v-model="form.password"
            type="password"
            required
            placeholder="Password"
            :disabled="hasNoToken"
            :state="(typeof formErrors.password !== 'undefined') ? false : null"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Confirm Password"
          label-for="confirmPassword"
          :invalid-feedback="formErrors.confirmPassword"
          :state="(typeof formErrors.confirmPassword !== 'undefined') ? false : true"
        >
          <b-form-input
            v-model="form.confirmPassword"
            type="password"
            required
            placeholder="Confirm Password"
            :disabled="hasNoToken"
            :state="(typeof formErrors.confirmPassword !== 'undefined') ? false : null"
          ></b-form-input>
        </b-form-group>
        <b-alert variant="danger" v-model="hasErrors">{{ error.msg }}</b-alert>
        <button
          type="submit"
          class="btn btn-primary btn-block"
          :disabled="hasNoToken"
        ><b-spinner small label="Spinning" v-if="sending"></b-spinner> Change Password</button>
      </b-form>
      <div v-else>
        <h2>Where do you want to go?</h2>
        <p>You have access to the following portal{{((portals.length !== 1) ? 's' : '' )}}, click on the logo to navigate there.</p>
        <div class="portal-links">
          <div v-for="portal in portals" :key="portals._id">
            <a :href="portal.url">
              <div :style="{
                'background-image': `url(${portal.img})`,
                'width': '180px',
                'height': '50px',
                'background-position': 'center',
                'background-size': 'cover',
                'margin': '20px auto'}">
                
              </div>
            </a>
          </div>
        </div>
      </div>
      <b-row
        v-if="subDomain === 'rider'"
       :style="{'padding': '20px 0 0 0', 'width': '350px'}"
        class="mobile-app-links"
      >
        <b-col cols="6">
          <a
            href="https://itunes.apple.com/au/app/shebah/id1168961723?mt=8"
            target="_blank"
            rel="noopener"
          >
            <img
              class="alignleft size-thumbnail wp-image-1936"
              style="width: 100%; border: 1px solid #aaa; border-radius: 10px;"
              src="//files.shebah.com.au/portal/img/apple_app_store.jpg"
              srcset="//files.shebah.com.au/portal/img/apple_app_store.jpg 1200w, //files.shebah.com.au/portal/img/apple_app_store.jpg 768w"
              sizes="(max-width: 1200px) 100vw, 1200px"
            />
          </a>
        </b-col>
        <b-col cols="6">
          <a
            href="https://play.google.com/store/apps/details?id=au.com.shebah.rider&amp;hl=en"
            target="_blank"
            rel="noopener"
          >
            <img
              class="alignleft wp-image-1937 size-thumbnail"
              style="width: 100%; border: 1px solid #aaa; border-radius: 10px;"
              src="//files.shebah.com.au/portal/img/google_play.jpg"
              alt
              srcset="//files.shebah.com.au/portal/img/google_play.jpg 1200w, //files.shebah.com.au/portal/img/google_play.jpg 768w"
              sizes="(max-width: 1200px) 100vw, 1200px"
            />
          </a>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import shebahApi from "@/services/shebah/index";

export default {
  name: "signIn",
  components: {},
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    },
    stateOptions() {
      return this.$store.getters["general/states"];
    },
    subDomain() {
      return this.$store.getters["general/subDomain"];
    }
  },
  watch: {},
  data() {
    return {
      form: {
        password: "",
        confirmPassword: ""
      },
      hasNoToken: false,
      hasErrors: false,
      successMessage: false,
      error: {},
      formErrors: {},
      redirectTimer: 60,
      redirectTimerInterval: null,
      redirectTimeout: null,
      portals: [],
      sending: false
    };
  },
  beforeCreate() {
    this.$cookie.delete("_t");
    this.$store.dispatch("authUser/updateUser", null);
    this.$store.dispatch("authUser/token", null);
    let body = document.getElementsByTagName("BODY")[0];
    // reset body class attribute
    body.className = "";
    body.classList.add("animsition");
    body.classList.add("page-forgot-password");
    body.classList.add("layout-full");
  },
  beforeDestroy() {
    clearInterval(this.redirectTimerInterval);
    clearTimeout(this.redirectTimeout);
  },
  created() {
    if (
      typeof this.$route.query !== "undefined" &&
      typeof this.$route.query.token !== "undefined" &&
      this.$route.query.token !== ""
    ) {
      this.hasNoToken = false;
      this.hasErrors = false;
    } else {
      this.hasNoToken = true;
      this.hasErrors = true;
      this.error.msg = "No reset token supplied!";
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.error = {};
        this.formErrors = {};
        this.hasErrors = false;

        if (this.form.password === "") {
          this.formErrors.password = "Password can not be blank!";
        }

        if (this.form.password.length < 8) {
          this.formErrors.password =
            "Password can not be less than 8 characters long!";
        }

        if (this.form.confirmPassword === "") {
          this.formErrors.confirmPassword =
            "Confirm password can not be blank!";
        }

        if (this.form.password !== this.form.confirmPassword) {
          this.formErrors = {
            confirmPassword: "Password and Confirm password do not match!"
          };
        }

        if (Object.keys(this.formErrors).length == 0) {
          this.sending = true;
          this.hasNoToken = true;
          let forgotPassword = await shebahApi.api.users.changePassword({
            token: this.$route.query.token,
            password: this.form.password
          });
          this.hasErrors = false;
          this.successMessage = true;
          this.form.password = "";
          this.form.confirmPassword = "";
          
          this.portals = forgotPassword.portals;
        }
      } catch (e) {
        
        if (typeof e.response !== "undefined") {
          this.error = e.response.data.error;
          if(typeof this.error.collection !== 'undefined') {
            this.formErrors = this.error.collection;
          }
          this.successMessage = false;
          this.hasErrors = true;
        } else {
          console.error(e);
        }
        this.sending = false;
        this.hasNoToken = false;
      }
    }
  }
};
</script>

<style lang="scss">
.page-login-main {
  &.page-sigup-main {
    padding: 60px;
  }
}
</style>
